import { render, staticRenderFns } from "./DataBlock.vue?vue&type=template&id=2d06bcc7&scoped=true&"
import script from "./DataBlock.vue?vue&type=script&lang=js&"
export * from "./DataBlock.vue?vue&type=script&lang=js&"
import style0 from "./DataBlock.vue?vue&type=style&index=0&id=2d06bcc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06bcc7",
  null
  
)

export default component.exports